import React from 'react';
import { StarterArticles } from '../../types/StarterGuideTypes';
import Article from './Article';
import './articles-layout.scss';

import ArticleSkeleton from './ArticleSkeleton';
import { getArticleImageLink, getArticleLink } from './content/contentHelper';

export const ArticlesLayout = ({
  data,
  recordAnalytics,
}: {
  data: StarterArticles | null;
  recordAnalytics: (analyticsEvent: string, analyticsLabel: string) => void;
}) => (
  <div className="starter-guide-articles starter-guide-container">
    {data ? (
      <>
        <h5 className="starter-guide-section-header">{data.title}</h5>
        <div className="starter-guide-articles__main" data-testid="starter-guide-articles">
          {data.articles.map((article, index) => (
            <div key={index} className="starter-guide-articles__container">
              <Article
                title={article.title || ''}
                image={getArticleImageLink(article.image, article.source)}
                link={getArticleLink(article.link, article.source)}
                logo={article.source}
                recordAnalytics={recordAnalytics}
              />
            </div>
          ))}
        </div>
      </>
    ) : (
      // Keeping this for future API integration
      <div className="starter-guide-articles__main" data-testid="starter-guide-articles-loading">
        <div className="starter-guide-articles__title starter-guide-articles__title--skeleton" />
        <ArticleSkeleton />
        <ArticleSkeleton />
      </div>
    )}
  </div>
);
